export default "__VITE_ASSET__CZk3ZsL8__"